import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ProfileContext from "../../context/ProfileContext";
import useAuth from "../../hooks/useAuth";
import { Avatar } from "@mui/material";

function CourseTableCourseOffering({ cID }) {
  let api = useAxiosPrivate();

  let {
    staffs,
    staffData,
    assign,
    assignStaffThoughClick,
    setshowSection,
    showSection,
    setAssigned,
    getStaffs,
  } = useContext(CourseAssignmentContext);

  let [staffsforoffering, setstaffsforOffering] = useState([]);
  let [dropdown, setdropdown] = useState(false);
  let [isMounted, setIsMounted] = useState(true);

  async function getCourseOffering(signal) {
    let resp = await api.get(
      `courseallocation/allocation/courseofferingforcoursetable?cID=${cID}`,
      {
        signal,
      }
    );

    isMounted && setstaffsforOffering(resp.data);
  }

  let {state}=React.useContext(ProfileContext)
  let {user}=useAuth()

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getCourseOffering(controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  async function handleAssign(sid) {
    let msg = await assignStaffThoughClick(sid);

    if (msg == true) {
      getStaffs(true);
      setshowSection({ ...showSection, courseCode: assign.course_code });

      setAssigned({});
    } else {
      alert(msg);
    }
  }

  if (staffsforoffering.length >= 1 == true) {
    return (
      <React.Fragment>
        {dropdown == false ? (
          <div className="course-table-courseoffering-container">
            <div className="staff-for-offering-container">
              {staffsforoffering.map((staff, index) => (
                <div
                  className="staff-div-on-offering"
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData("staffId", staff.id);
                  }}
                  key={index}
                >
                  <Avatar
                  src={state.host+staff.User?.profile_pic.slice(1,)+`?token=${user?.accessToken}`}

                    // src={require("../../assets/images/ppic.jfif")}
                    alt={staff.first_name}
                    sx={{
                      cursor: "pointer",
                    }}
                    draggable
                    onDragStart={(e) => {
                      e.dataTransfer.setData("staffId", staff.id);
                    }}
                  />

                  <span
                    style={{
                      marginLeft: "3px",
                      marginRight: "3px",
                    }}
                    draggable
                    onDragStart={(e) => {
                      e.dataTransfer.setData("staffId", staff.id);
                    }}
                  >
                    {staff.User !== null &&
                      staff.User.first_name + " " + staff.User.last_name}
                  </span>

                  {assign.courseCode != null && (
                    <AddCircleIcon
                      sx={{
                        color: "#cd853f",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleAssign(staff.id);
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
            {staffsforoffering.length > 3 == true && (
              <div
                style={{
                  width: "5%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingLeft: "5px",
                }}
              >
                <KeyboardArrowDownIcon
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setdropdown(true);
                  }}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="course-table-courseoffering-container-dropdown">
            <div className="staff-for-offering-container-dropdown">
              {staffsforoffering.map((staff, index) => (
                <div
                  className="staff-div-on-offering"
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData("staffId", staff.id);
                  }}
                  key={index}
                >
                  <img
                    src={require("../../assets/images/ppic.jfif")}
                    alt=""
                    draggable="true"
                    onDragStart={(e) => {
                      e.dataTransfer.setData("staffId", staff.id);
                    }}
                  />

                  <span
                    draggable
                    onDragStart={(e) => {
                      e.dataTransfer.setData("staffId", staff.id);
                    }}
                  >
                    {staff.User !== null &&
                      staff.User.first_name + " " + staff.User.last_name}
                  </span>
                  {assign.courseCode != null && (
                    <AddCircleIcon
                      sx={{
                        color: "#cd853f",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleAssign(staff.id);
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
            <div
              style={{
                width: "5%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <KeyboardArrowUpIcon
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  setdropdown(false);
                }}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default CourseTableCourseOffering;
